export const ANSWER = {
  id: null,
  answer: null,
};

export const QUESTION = {
  id: null,
  question: null,
  answer_id: null,
  size_id: null,
};

export const CELL_SIZE = 60;

export const CELL = {
  id: null,
  type: 'col',
  hide: false,
  height: 100,
  text: null,
  positionx: 0,
  positiony: 0,
  updated: true,
  settings: {
    locked: false,
    type: 'criptogram',
  },
  answer_id: null,
  question_id: null,
  answer: { ...ANSWER },
  question: { ...QUESTION },
  isAnswer: false,
};

export const DEFAULT_SETTINGS = {
  cryptogramFont: null,
  cryptogramTheme: 'default',
};

export const MODEL = {
  id: null,
  name: null,
  slug: null,
  type_id: 2,
  rows: 1,
  columns: 10,
  settings: { ...DEFAULT_SETTINGS },
  created_at: new Date(),
  updated_at: new Date(),
  table: [{ ...CELL }],
};
